import { Injectable, signal } from '@angular/core';

export type messageTypes = 'mtInfo' | 'mtWarning' | 'mtSuccess' | 'mtError';

interface WidgetMessage {
  code?: number
  message?: string
  messageTye?: messageTypes
}

@Injectable({
  providedIn: 'root'
})
export class WidgetMessageService {
  private _widgetMessageCode = 200;
  private _widgetMessage = '';
  private _widgetMessageType: messageTypes = 'mtSuccess';
  private _widgetMessageDuration = 3000;

  public showMessage$ = signal<boolean>(false);

  private toggleShowMessage(): void {
    this.showMessage$.update((oldValue: boolean) => {
      return !oldValue;
    });
  }

  public setMessage(widgetMessage: WidgetMessage) {
    // 1. Reset the internal message string so we don't append to old errors
    this._widgetMessage = '';

    let hasContent = false;

    // Handle Code-based messages
    if (widgetMessage.code) {
      hasContent = true;
      if (!widgetMessage.message) {
        this._widgetMessage = this.getDefaultMessageForCode(widgetMessage.code);
      }
    }

    // Handle Explicit String messages (Overrides code-based default)
    if (widgetMessage.message) {
      hasContent = true;
      this._widgetMessage = widgetMessage.message;
    }

    if (widgetMessage.messageTye) {
      this._widgetMessageType = widgetMessage.messageTye;
    }

    if (hasContent) {
      // 2. Set the signal to true to show the UI
      this.showMessage$.set(true);

      // 3. Clear existing timeouts if any (Optional but safer)
      // 4. Set timeout to hide the message
      setTimeout(() => {
        this.showMessage$.set(false);
        this._widgetMessage = '';
      }, this._widgetMessageDuration);
    }
  }

  private getDefaultMessageForCode(code: number): string {
    switch (code) {
      case 200: case 201: case 204: return 'Daten erfolgreich geladen';
      case 400: return 'Fehlerhafte Anfrage';
      case 401: case 403: return 'Authentifizierung fehlerhaft';
      case 404: return 'Ressource nicht gefunden';
      case 422: return 'Validierungsfehler';
      case 429: return 'Zu viele Anfragen';
      default: return `Fehler (Status: ${code})`;
    }
  }

  public get widgetMessage(): string {
    return this._widgetMessage;
  }

  public get widgetMessageCode(): number {
    return this._widgetMessageCode;
  }

  public get widgetMessageType(): messageTypes {
    return this._widgetMessageType;
  }

  public get widgetDuration(): number {
    return this._widgetMessageDuration;
  }

  public set widgetShowMessage(value: boolean) {
    this.showMessage$.set(value);
  }
}
